"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.photoKeyPrefix = exports.importerInitials = void 0;
var keyPart = function (value) { return value.toLowerCase().replace(/[^a-z\d]/g, ''); };
var importerInitials = function (user) {
    return "".concat(user.lastName.slice(0, 2)).concat(user.firstName.slice(0, 2)).toLowerCase();
};
exports.importerInitials = importerInitials;
var photoKeyPrefix = function (text, user) {
    var collection = null;
    var objectNumber = null;
    if (text.excavationPrefix && text.excavationNumber) {
        collection = text.excavationPrefix;
        objectNumber = text.excavationNumber;
    }
    else if (text.museumPrefix && text.museumNumber) {
        collection = text.museumPrefix;
        objectNumber = text.museumNumber;
    }
    else if (text.publicationPrefix && text.publicationNumber) {
        collection = text.publicationPrefix;
        objectNumber = text.publicationNumber;
    }
    if (collection === null || objectNumber === null) {
        return null;
    }
    return "".concat(keyPart(collection.toLowerCase().replace('kt', '')), "-").concat(keyPart(objectNumber), "-").concat((0, exports.importerInitials)(user), "-");
};
exports.photoKeyPrefix = photoKeyPrefix;
//# sourceMappingURL=photoKeys.js.map